/* @flow */

import { useEffect, useState } from "react";
import { throttle } from "diskho";
import { useBrowser } from "@awardit/react-use-browser";

type Direction = "lt" | "gt";

const useDevice = (direction: Direction, breakpoint: number = 550): boolean => {
  const browser = useBrowser();
  const [width, setWidth] = useState(browser ? window.innerWidth : 1200);

  useEffect(() => {
    if (browser) {
      setWidth(window.innerWidth);
      const handleResize = throttle(() => setWidth(window.innerWidth), 1000);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, [browser]);

  return direction === "gt" ? width > breakpoint : width < breakpoint;
};

export default useDevice;
